/**
 * @author Jensen<zhhnch@gmail.com>
 * @description
 * @since 2018/3/29
 */

import {mapState, mapActions, Store} from 'vuex';

const gSetPermissions = 'gSetPermissions';

const plugin = {

    install(Vue, options) {

        if (options && options.store && options.store instanceof Store) {
            // do nothing
        } else {
            throw new Error('gRac required a vuex store instance.');
        }

        let {store} = options;

        store.registerModule('gPermissions', {
            state: {
                permissions: {}
            },
            getters: {},
            mutations: {
                [gSetPermissions](state, permissions) {
                    let tmp = {};
                    for (let k in permissions) {
                        if (permissions.hasOwnProperty(k) && permissions[k]) {
                            tmp[k] = !!permissions[k];
                        }
                    }
                    state.permissions = tmp;
                }
            },
            actions: {
                [gSetPermissions]({commit}, payload) {
                    commit(gSetPermissions, payload);
                }
            }
        });

        Vue.mixin({
            computed: {
                ...mapState({
                    gPermissions: state => state.gPermissions.permissions
                })
            },
            methods: {
                ...mapActions([
                    gSetPermissions
                ]),
                gRac(code) {
                    return this.gPermissions.hasOwnProperty(code);
                }
            }
        });

        Vue.directive('gRac', (el, binding) => {
            const accessDenied = !binding.value;
            const styleAttr = 'style';
            const hiddenStr = 'visibility:hidden;display:none !important';
            let styleStr = (el.getAttribute(styleAttr) || '').replace(hiddenStr, '');
            if (accessDenied) {
                styleStr += `;${hiddenStr}`;
            }
            styleStr = styleStr.replace(/(^[;])|([;]$)/g, '');
            styleStr ? el.setAttribute(styleAttr, styleStr) : el.removeAttribute(styleAttr);
        });
    }
};

export default plugin;



// WEBPACK FOOTER //
// ./src/plugins/rac.js